import 'jquery';
import { FTScroller } from 'ftscroller';

import dt from 'datatables.net';
import dt_bootstrap from 'datatables.net-bs';
import dt_responsive from 'datatables.net-responsive';

import { unifyTableResponsive } from  './jquery.unifyTableResponsive';

export class UnifyTables {
    constructor(selector, options) {
        //this.addDataTablesToJquery(window, $); // -Use a static variable to make sure that we have jquery support.
        if (typeof selector !== 'undefined' &&
            selector !== '') {
            this._selector = selector;
            $(selector).DataTable(options);
        }
    }

    GetDataTableFunction() { return $(this._selector).DataTable; }
    GetDataTableObject() { return this.GetDataTableFunction()(); }

    addDataTablesToJquery(window, $) {
        this._initialize(window, $);
    }

    _initialize(window, $) {
        // add datatable files
        if (typeof $ === 'undefined' || typeof window === 'undefined') {
            console.log('unifyDataTables are beeing called with wrong parameters, both window and jQuery $ must be used in the constructor');
            return;
        }
        // add datatable, datatable bootstrap if not already added to jquery variable
        if (typeof $.fn.DataTable === 'undefined') {
            dt(window, $);
            dt_bootstrap(window, $);
        }
        if (typeof $.fn.dataTable.Responsive === 'undefined') {
            dt_responsive(window, $);
        }
    }

    // must be called before constructor if used as in option of datatable constructor, therefore static
    static AddUnifyTableResponsiveToJquery($) {
        var test = new unifyTableResponsive($);
    }

    AddHorizontalScroll() {
        var tables = $(this._selector);
        for (var i = 0; i < tables.length; i++) {
            this.constructor._AddHorizontalScroll(tables.get(i));
        }
    }

    injectHorizontalScroll(tableSelector) {
        var dataTables;
        if (tableSelector) {
            dataTables = $('table' + tableSelector);
        } else {
            dataTables = $('table.datatables-horizontal-scroll, table.unify-datatables-horizontal-scroll');
        }
        for (var i = 0; i < dataTables.length; i++) {
            this.constructor._AddHorizontalScroll(dataTables.get(i));
        }
    }

    static _AddHorizontalScroll(dataTable) {
        var dataTableParent = $(dataTable).parent().get(0);
        var qDatatableParentParent = $(dataTable).parent().parent();
        var dataTableHasScroller = qDatatableParentParent.length > 0 && qDatatableParentParent.hasClass('ftscroller_container');

        if (!dataTableHasScroller) {
            var ftscroller = new FTScroller(dataTableParent, {
                scrollingY: false,
                scrollbars: false,
                bouncing: false,
                updateOnWindowResize: true,
                disabledInputMethods: { scroll: true }
            });

            this._onFTScrollerScrollabilityChange(ftscroller, function (canScrollRight, canScrollLeft) {
                if (canScrollRight) {
                    $(ftscroller.contentContainerNode).parent().addClass('can_scroll_right');
                } else {
                    $(ftscroller.contentContainerNode).parent().removeClass('can_scroll_right');
                }

                if (canScrollLeft) {
                    $(ftscroller.contentContainerNode).parent().addClass('can_scroll_left');
                } else {
                    $(ftscroller.contentContainerNode).parent().removeClass('can_scroll_left');
                }
            }, { 'scroll': true });

            /* Removes or adds the scroll indicators when table columns are resized (normally triggerred when the window is resized) */
            $(dataTable).dataTable().on('column-sizing.dt', function () {
                var isScrollable = $(ftscroller.contentContainerNode).parent().innerWidth() < ftscroller.scrollWidth;
                if (isScrollable) {
                    $(ftscroller.contentContainerNode).parent().addClass('can_scroll_right');
                } else {
                    $(ftscroller.contentContainerNode).parent().removeClass('can_scroll_right');
                }
            });

        }
    }

    static _onFTScrollerScrollabilityChange(ftscroller, callback) {

        if (disabledTriggers == undefined) {
            var disabledTriggers = {};
        }

        var endX = Number.MAX_VALUE;

        /* Math.ceil is used because scrollWidth seems to be rounded */
        var isScrollable = Math.ceil($(ftscroller.contentContainerNode).parent().innerWidth()) < ftscroller.scrollWidth;

        var canScrollRight = isScrollable;
        var canScrollLeft = false;

        if (isScrollable) {
            callback(true, canScrollLeft);
        }

        /* This ensures the scroller is updated even if data are added dynamically slightly later */
        window.setTimeout(function () {
            ftscroller.updateDimensions();

            endX = Number.MAX_VALUE;

            isScrollable = Math.ceil($(ftscroller.contentContainerNode).parent().innerWidth()) < ftscroller.scrollWidth;

            if (isScrollable) {
                callback(canScrollRight, canScrollLeft);
            }
        }, 500);

        if (!disabledTriggers['resize']) {
            $(window).on('resize', function () {
                endX = Number.MAX_VALUE;

                isScrollable = Math.ceil($(ftscroller.contentContainerNode).parent().innerWidth()) < ftscroller.scrollWidth;
                if (isScrollable) {
                    canScrollRight = true;
                } else {
                    canScrollRight = false;
                }

                callback(canScrollRight, canScrollLeft);
            });
        }

        if (!disabledTriggers['scroll']) {
            ftscroller.addEventListener('scroll', function (event) {

                canScrollRight = !(event.scrollLeft >= endX);
                canScrollLeft = !(event.scrollLeft <= 0);

                callback(canScrollRight, canScrollLeft);
            });
        }

        /* This seems to be the only way to tell when it's not possible to scroll to the right anymore */
        ftscroller.addEventListener('reachedend', function (event) {
            /* Timeout was used to get around a bug where scrollLeft wasn't set until some time after reachedend had occured */
            window.setTimeout(function () {
                endX = event.srcObject.scrollLeft - 1;
                callback(false, canScrollLeft);
            }, 100);
        });
    }

    /**
     * Child rows
     */

    formatChildRows(tableSelector, formattingFunction, shouldMakeFullWidth) {
        // Add event listener for showing and hiding tr child
        var that = this;
        $(tableSelector + ' tbody').on('click', 'td.unify-table-expandbutton', function () {
            that._onClickExpandbutton.call(this, that, tableSelector, formattingFunction, shouldMakeFullWidth);
        });
    }

    _onClickExpandbutton(classScope, tableSelector, formattingFunction, shouldMakeFullWidth) {
        var tr = $(this).closest('tr');
        var row = $(tableSelector).DataTable().row(tr);
        var htmlChildContent = formattingFunction(row.data());

        if (row.child.isShown()) {
            row.child.hide();
            tr.removeClass('unify-table-row--showing-child');

        } else if (htmlChildContent) {
            classScope._appendChildRow(tr, row, htmlChildContent, shouldMakeFullWidth);
        }
        /* We need to add the click listener, even for rows that shouldn't be clickable, 
         * since we need the click event to determine which row was clicked. */
    }

    _appendChildRow(tr, row, htmlChildContent, shouldMakeFullWidth) {

        var classChild = 'unify-table-row--child';
        var classChildCell = 'unify-table-row--child__cell';
        var numColumns = row.columns()[0].length;

        var childRow = document.createElement('tr');

        childRow.classList.add(classChild);

        if (shouldMakeFullWidth) {
            $(childRow).append(
                '<td class="' + classChildCell + '" colspan="' + numColumns + '">' + htmlChildContent + '</td>'
            );
        } else {
            $(childRow).append(
                '<td class="' + classChildCell + '"></td>' +
                '<td class="' + classChildCell + '" colspan="' + (numColumns - 1) + '">' + htmlChildContent + '</td>'
            );
        }
        row.child(childRow).show();
        tr.addClass('unify-table-row--showing-child');
    }

}